/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DsaiBatchPageCapExceededCode {
    BATCH_PAGE_CAP_EXCEEDED = 'batch_page_cap_exceeded',
}
